import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import Button from '@material-ui/core/Button';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import axios from 'axios';
import i18n from '../../i18n';
import Errorbar from '../common/errorbar';
import MushroomImg from '../../img/mushroom.jpg';
import PortalImg from '../../img/portalImg.jpg';
import Logo from '../../img/logo.png';
import HorseImg from '../../img/horseImg.jpg';
import BlockChainImage from '../../img/blockChainImage.jpg';
import HorseAndHumanImg from '../../img/horseAndHuman.jpg';
import GetStraw from '../../img/getStraw.jpg';
import SpreadStraw from '../../img/spreadStraw.jpg';
import StrawRecovery from '../../img/strawRecovery.jpg';
import StrawConvey from '../../img/strawConvey.jpg';
import MushroomBed from '../../img/mushroomBed.jpg';
import BeginCultivation from '../../img/beginCultivation.jpg';
import Cultivation from '../../img/cultivation.jpg';
import Harvest from '../../img/harvest.jpg';
//参加団体のロゴ
import CaicaLogo from '../../img/caica_logo.png';
import CaicatechLogo from '../../img/caicatech_logo.png';
import GeofarmLogo from '../../img/geofarm_logo.png';
/** add tk */
import IMG_mushQR from '../../img/mashu_qr_code.jpg';
import IMG_wallet_login from '../../img/wallet_login_cut.jpg';
import IMG_wallet_login_new from '../../img/wallet_login_cut_new.jpg';
import IMG_wallet_loginTop from '../../img/wallet_loginTop_cut.jpg';
import IMG_wallet_coinview from '../../img/wallet_coinview.jpg';
import IMG_gioEc_kessai from '../../img/gioEc_kessai.jpg';
import IMG_GeoCaica_Logo from '../../img/GeoXCaicaTec.png'

import IMG_NelCafe_Logo from '../../img/nelcafe_logo.jpg';
import IMG_NelCafe_Logo2 from '../../img/nelcafe_logo2.jpg';
import IMG_NelCage_gezel from '../../img/nelcafe_gezel.jpg';
import IMG_NelCage_coffee from '../../img/nelcafe_cofee.jpg';
import IMG_NelCage_coffeeCake from '../../img/nelcafe_cofeecakeset.jpg';
/** maintenance#2 t.k */
import IMG_NasuTF_Logo  from '../../img/nasutfSBlue_logo.jpg';
import IMG_NasuTF_jyoba from '../../img/nasutf_jouba.jpg';
import IMG_NasuTF_LogoL from '../../img/nasutfName_logo.jpg';
/** */

class MoblieHome extends Component { 
    constructor(props){
        super(props)
        this.state = {
            sponsors:[],
            farms:[],
            notices:[],
            network_err:false,
            open:false,
            noticeTitle:"",
            noticeMessage:"",
            noticeReleaseDate:"",
            noDataErr:false,
            company:[]
        }
    }

    getFarmList=()=>{
        var api = process.env.REACT_APP_ENDPOINT + 'farm/'
        axios.get(api)
        .then((response)=>{
            this.setState({farms:response.data, noDataErr:false})
        })
        .catch((error)=>{
            console.log(error)
            this.handleErrorbarOpen()
            if(typeof error.response != "undefined" && error.response.status === 500){
                this.setState({errorMessage:i18n.t('home.no_farm_data')})
            }else if(typeof error.response != "undefined" && error.response.status === 501){
                this.setState({noDataErr:true, errorMessage:i18n.t('home.can_not_get_data')})
            }else{
                this.setState({noDataErr:true, errorMessage:i18n.t('home.server_error')})
            }
        })
    }

    getSponsorList=()=>{
        var api = process.env.REACT_APP_ENDPOINT + 'sponsor/'
        axios.get(api)
        .then((response)=>{
            this.setState({sponsors:response.data, noDataErr:false})
        })
        .catch((error)=>{
            console.log(error)
            this.handleErrorbarOpen()
            if(typeof error.response != "undefined" && error.response.status === 500){
                this.setState({errorMessage:i18n.t('home.no_sponsor_data')})
            }else if(typeof error.response != "undefined" && error.response.status === 501){
                this.setState({noDataErr:true, errorMessage:i18n.t('home.can_not_get_data')})
            }else{
                this.setState({noDataErr:true, errorMessage:i18n.t('home.server_error')})
            }
        })
    }

    // 取り扱い企業一覧を取得する
    getStoresCompanyList=()=>{
        var api = process.env.REACT_APP_ENDPOINT + 'store/'
        axios.get(api)
        .then((response)=>{
            this.setState({company:response.data})
        }).catch((error)=>{
            console.log(error)
            this.handleErrorbarOpen()
            this.setState({noDataErr:true, errorMessage:i18n.t('home.server_error')})
        })
    }

    getdata(){
        this.getFarmList()
        this.getSponsorList()
        this.getStoresCompanyList()
    }

    componentWillMount(){
        this.getdata()
    }

    componentDidUpdate(){
        this.render()
    }

    sendState=()=>{
        var target = window.event.target
        var id = target.getAttribute("id")
        this.props.history.push({
            pathname:"/flows",
            state:{selectedFlow:id}
        })
    }

    // 取り扱い店舗をクリックする時
    sendCompanyInfo = () => {
        var target = window.event.target
        var id = target.getAttribute("id")
        this.props.history.push({
            pathname:"/stores/",
            state:{companyName:id}
        })
    }

    // 文字の色チェンジ
    changeColorToBlue = (e) => {
        e.currentTarget.style.color = "blue"
    }
  
    changeColorToBlack = (e) => {
        e.currentTarget.style.color = "black"
    }

    handleErrorbarOpen=()=>{
        this.setState({openErrorBar:true})
    }

    handleErrorbarClose=()=>{
        this.setState({openErrorBar:false})
    }

    render() {

        //農場と協賛企業を合わせる
        var partnersList = []
        this.state.farms.forEach(item => partnersList.push(item))
        this.state.sponsors.forEach(item => partnersList.push(item))
        //参加団体一覧を表示
        var partners = partnersList.map((item,index)=>{
            return(
                <div key={index} style={styles.partners_area}>
                    <img src={item.logo_path} style={styles.partners_logo}></img>
                    <a href={item.url} target="_Blank" style={{position:"relative", color:"black", textDecoration:"underline"}}><span>{item.name}</span></a>
                </div>
            )
        })

        // 取り扱い企業リスト
        var storesCompany = this.state.company.map((item,index)=>{
            // var href = "/stores/"
            return(
                <div key={index} style={styles.stores_company_list}>
                    <a id={item.name} onClick={this.sendCompanyInfo} style={{color:"black"}} onMouseOver={this.changeColorToBlue} onMouseOut={this.changeColorToBlack}>・ {item.name}</a>
                </div>
            )
        })

        //サーバー障害が発生する時
        if(this.state.noDataErr == true){
            partners.push(
                <div key={"noDataErr"}>
                    <p style={{textAlign:"center", fontSize:"30px", color:"red", marginTop:"30px"}}>{i18n.t('home.can_not_get_sponsor_data')}</p>
                </div>
            )
            storesCompany.push(
                <div key={"noDataErr"}>
                    <p style={{textAlign:"center", fontSize:"30px", color:"red", marginTop:"30px"}}>{i18n.t('home.can_not_get_store_data')}</p>
                </div> 
            )
        }

        return (
            <div>
                <Errorbar open={this.state.openErrorBar} handleClose={this.handleErrorbarClose} message={this.state.errorMessage} />
                <div id="portal_title" style={styles.elements}>
                    <div>
                        <img src={Logo} style={styles.logoImg}></img>
                        <div className="textArea" style={styles.portalTextArea}>
                            <p style={styles.portalTitle}>{i18n.t('home.top_title')}</p>
                            <p style={styles.portalText}>
                                {i18n.t('home.top_title_label_1')}
                                <br/>
                                {i18n.t('home.top_title_label_2')}
                                <br/>
                                {i18n.t('home.top_title_label_3')}
                                <br/>
                                {i18n.t('home.top_title_label_4')}
                            </p>
                        </div>
                    </div>
                    <img className="background" src={PortalImg} style={styles.portalImg}></img>
                </div>
                <div id="introduction" style={styles.elements}>
                    <div className="textAera" style={{width:"80%", marginLeft:"10%", marginTop:"50px"}}>
                        <h1 style={styles.introductionTitle}>{i18n.t('home.horse_second_career')}</h1>
                        <hr color="#666666" size="3"></hr>
                        <p style={styles.introductionText}>{i18n.t('home.about_second_career')}</p>
                    </div>
                    <img src={HorseAndHumanImg} style={{width:"100%", marginTop:"20px"}}></img>
                    <div className="textAera" style={{width:"80%", marginLeft:"10%", marginTop:"50px"}}>
                        <h1 style={styles.introductionTitle}>
                            {i18n.t('home.mushroom_point_1')}
                            <br/>
                            {i18n.t('home.mushroom_point_2')}
                        </h1>
                        <hr color="#666666" size="3"></hr>
                        <p style={styles.introductionText}>{i18n.t('home.about_mushroom_point')}</p>
                    </div>
                    <img src={HorseImg} style={{width:"100%", marginTop:"20px"}}></img>
                    <div className="textAera" style={{width:"80%", marginLeft:"10%", marginTop:"50px"}}>
                        <h1 style={styles.introductionTitle}>{i18n.t('home.traditional_cultivation')}</h1>
                        <hr color="#666666" size="3"></hr>
                        <p style={styles.introductionText}>{i18n.t('home.about_traditional_cultivation')}</p>
                    </div>
                    <img src={MushroomImg} style={{width:"100%", marginTop:"20px"}}></img>
                </div>
                {/**　全体概要図 */}
                <div id="about_blockchain" style={styles.elementsColored}>
                    <div className="textAera" style={{width:"82%", marginLeft:"9%", marginTop:"50px"}}>
                        <h1 style={styles.introductionTitle}>{i18n.t('home.horse_and_blockchain')}</h1>
                        <hr color="#666666" size="3"></hr>
                        <p style={styles.introductionText}>
                            {i18n.t('home.about_process_label_1')}
                            <br/>
                            {i18n.t('home.about_process_label_2')}
                            <br/>
                            {i18n.t('home.about_process_label_3')}
                        </p>
                        <img src={IMG_GeoCaica_Logo} style={styles.geoCaicaLogoImg}/>
                    </div>
                    <img src={BlockChainImage} style={{width:"100%", marginTop:"20px"}}></img>
                    <p style={styles.pBlockChain}/>
                </div>
                {/** コインについて */}
                <div id="about_coin" style={styles.elements}>
                    <div style={{width:"80%", marginLeft:"5%", marginTop:"50px"}}>
                        <div className="textArea" style={{display:"inline-block", verticalAlign:"top", marginLeft:"5%", fontSize:"25px", width:"95%"}}>
                            <h1 style={{fontSize:"40px", fontWeight:"600"}}>{i18n.t('home.coin_mainTitle')}</h1>
                            <ul><p style={{lineHeight:"45px", marginTop:"-25px"}}>
                                {/** ウマッシュコインとは */}
                                <h1 style={styles.coin_sub_title}><li>{i18n.t('home.coin_umushis_lead')}</li></h1>
                                {i18n.t('home.coin_umushis_Explan')}
                            </p></ul>
                        </div>
                    </div>
                    {/** ウマッシュを貯めるには */}
                    <div style={{width:"80%", marginLeft:"10%", marginTop:"-30px"}}>
                        <div className="textArea" style={{display:"inline-block", verticalAlign:"top", fontSize:"25px", width:"95%"}}>
                            <ul><p style={{marginTop:"5px", lineHeight:"45px"}}>
                                <h1 style={styles.coin_sub_title}><li>{i18n.t('home.coin_save_lead')}</li></h1>
                                {i18n.t('home.coin_save_Explan1')}
                                <span style={{fontSize:"70%"}}>{i18n.t('home.coin_save_Explan2')}</span>
                                {i18n.t('home.coin_save_Explan3')}
                                <span style={{fontSize:"70%"}}>{i18n.t('home.coin_save_Explan4')}</span>
                                {i18n.t('home.coin_save_Explan5')}
                                <span style={{marginLeft:"5%",lineHeight:"1px",fontSize:"75%"}}>
                                <br/>{i18n.t('home.coin_save_note1')}
                                <br/>{i18n.t('home.coin_save_note2')}
                                <br/>{i18n.t('home.coin_save_note3')}
                                <br/>{i18n.t('home.coin_save_note4')}
                                </span>
                            </p></ul>
                            {/** 操作説明 貯めるには*/}
                            <img src={IMG_mushQR} style={styles.blockChainImage_coin}></img>
                            <div className="coin_save_op1" style={{display:"inline-block", marginLeft:"5%" ,width:"50%", verticalAlign:"top", marginTop:"10px"}}>
                                <p style={styles.textRight}>
                                    {i18n.t('home.coin_save_ope1')}
                                </p>
                            </div>
                            <img src={IMG_wallet_login_new} style={styles.blockChainImage_coin}></img>
                            <div className="coin_save_op1" style={{display:"inline-block", marginLeft:"5%" ,width:"50%", verticalAlign:"top", marginTop:"10px"}}>
                                <p style={styles.textRight}>
                                    {i18n.t('home.coin_save_ope2')}
                                </p>
                            </div>
                            <img src={IMG_wallet_coinview} style={styles.blockChainImage_coin}></img>
                            <div className="coin_save_op1" style={{display:"inline-block", marginLeft:"5%" ,width:"50%", verticalAlign:"top", marginTop:"10px"}}>
                                <p style={styles.textRight}>
                                    {i18n.t('home.coin_save_ope3')}
                                </p>
                            </div>
                        </div>
                    </div>
                    {/** コインの確認*/}
                    <div style={{width:"80%", marginLeft:"10%"}}>
                        <div className="textArea" style={{display:"inline-block", verticalAlign:"top", fontSize:"25px", width:"95%"}}>
                            <ul><p style={{marginTop:"5px", lineHeight:"45px"}}>
                                <h1 id="coin_conf_lead" style={styles.coin_sub_title}><li>{i18n.t('home.coin_conf_lead')}</li></h1>
                                {i18n.t('home.coin_conf_Explan1')}
                                <span style={{fontSize:"70%"}}>{i18n.t('home.coin_conf_Explan2')}</span>
                                {i18n.t('home.coin_conf_Explan3')}
                                <span style={{fontSize:"80%", lineHeight:"40px"}}>
                                <br/>{i18n.t('home.coin_conf_note1')}
                                </span>
                            </p></ul>
                            {/**操作方法　コイン確認 */}
                            <img src={IMG_wallet_loginTop} style={styles.blockChainImage_coin}></img>
                            <div className="coin_save_op1" style={{display:"inline-block", marginLeft:"5%" ,width:"50%", verticalAlign:"top", marginTop:"10px"}}>
                                <p style={styles.textRight}>
                                    {i18n.t('home.coin_conf_ope1-1')}<br/>
                                    <a href="https://wallet.food-action-for-horses.jp" target="_blank">https://wallet.food-action-for-horses.jp</a><br/>
                                    {i18n.t('home.coin_conf_ope1-2')}
                                </p>
                            </div>
                            <img src={IMG_wallet_login} style={styles.blockChainImage_coin}></img>
                            <div className="coin_save_op1" style={{display:"inline-block", marginLeft:"5%" ,width:"50%", verticalAlign:"top", marginTop:"10px"}}>
                                <p style={styles.textRight}>
                                    {i18n.t('home.coin_conf_ope2')}
                                </p>
                            </div>
                            <img src={IMG_wallet_coinview} style={styles.blockChainImage_coin}></img>
                            <div className="coin_save_op1" style={{display:"inline-block", marginLeft:"5%" ,width:"50%", verticalAlign:"top", marginTop:"10px"}}>
                                <p style={styles.textRight}>
                                    {i18n.t('home.coin_conf_ope3')}
                                </p>
                            </div>
                        </div>
                    </div>
                    {/** パックの販売所コインの確認*/}
                    <div style={{width:"80%", marginLeft:"10%"}}>
                        <div className="textArea" id="stores" style={{display:"inline-block", verticalAlign:"top", width:"100%"}}>
                            <ul><p style={styles.coin_howt_Sale_Title}>
                                <h1 id="coin_conf_Sales" style={styles.coin_sub_title}><li>{i18n.t('home.coin_conf_Sales')}</li></h1>
                            </p></ul>
                            <span style={styles.coin_howto_Sales_note}>{i18n.t('home.coin_howt_Sales_note')}</span>
                            {storesCompany}
                        </div>
                    </div>
                    {/** マッシュルームが食べられる飲食店一覧　feature#2 T.k*/}
                    <div style={{width:"80%", marginLeft:"10%"}}>
                        <div className="testArea" id="restaurants" style={{display:"block", verticalAlign:"top", width:"100%"}}>
                            <ul><p style={{marginTop:"5px", lineHeight:"30px"}}>
                                <h1 id="coin_conf_Sales" style={styles.coin_sub_title}><li>{i18n.t('home.coin_conf_Restaurant')}</li></h1>
                            </p></ul>
                            <p style={styles.introductionText}>
                                {i18n.t('home.coin_howt_Restaurant_note1')} 
                                <a href="restaurants/">{i18n.t('home.coin_howt_Restaurant_note2')}</a>
                                {i18n.t('home.coin_howt_Restaurant_note3')}
                            </p>
                        </div>
                    </div>
                {/** コインの利用方法 */}
                <div style={{width:"80%", marginLeft:"10%"}}>
                    {/** コインの利用方法 */}
                    <div className="textArea" style={{display:"inline-block", verticalAlign:"top", width:"100%"}}> 
                        {/** タイトル */}
                        <h1 style={styles.coin_sub_title}><li>{i18n.t('home.coin_howt_lead')}</li></h1>
                        {/** 利用先別 */}
                        <div style={styles.coin_howt_Block}>
                            {/** 項目名：ジオファーム */}
                            <h1 style={styles.coin_howt_Item}>{i18n.t('home.coin_howt_gio')}</h1>
                            {/** 説明文：ジオファーム */}
                            <div style={{marginTop:"5px", fontSize:"25px", lineHeight:"45px"}}>
                                {i18n.t('home.coin_howt_gio_Explan1')}
                                <a href="https://geo-farm.com" target="_blank">https://geo-farm.com</a>{i18n.t('home.coin_howt_gio_Explan2')}
                                <span style={{fontSize:"70%"}}>{i18n.t('home.coin_howt_gio_Explan3')}</span>
                                {i18n.t('home.coin_howt_gio_Explan4')}<br/>
                                <span style={{marginLeft:"20px", fontSize:"80%", verticalAlign:"top", lineHeight:"40px"}}>{i18n.t('home.coin_howt_gio_note1')}</span>
                                <img src={IMG_gioEc_kessai} style={{marginTop:"10px", marginLeft:"20px", width:"65%"}}></img>
                            </div>
                        </div>
                        <p style={{height:"20px"}}></p>
                        <div style={styles.coin_howt_Block}>
                            {/** 項目名：ネルカフェ */}
                            <h1 style={styles.coin_howt_Item}>{i18n.t('home.coin_howt_nel')}</h1>
                            <p style={styles.coin_howt_Intro}>{i18n.t('home.coin_howt_Intro')}</p>
                            <img src={IMG_NelCafe_Logo2} style={styles.nelCafeLogoHorizontal}/>
                            <div lassName="textArea" style={{display:"inline-block", marginLeft:"5%" , width:"60%", verticalAlign:"top", marginTop:"0px", fontSize:"25px", lineHeight:"45px"}}>
                                {i18n.t('home.coin_howt_nel_Explan1-1')}<br/>{i18n.t('home.coin_howt_nel_Explan1-2')}
                                <a href="#coin_conf_lead">{i18n.t('home.coin_howt_nel_Explan1-3')}</a>
                                {i18n.t('home.coin_howt_nel_Explan1-4')}
                            </div><br/>
                            <img src={IMG_NelCafe_Logo} style={styles.nelCafeImage}/>
                            <img src={IMG_NelCage_coffee} style={styles.nelCafeImage}/>
                            <img src={IMG_NelCage_gezel} style={styles.nelCafeImage}/>
                            <img src={IMG_NelCage_coffeeCake} style={styles.nelCafeImage}/>
                        </div>
                        <div style={styles.coin_howt_Block}>
                            {/** 項目名：那須トレーニングファーム */}
                            <p style={{height:"20px"}}></p>
                            <h1 style={styles.coin_howt_Item}>{i18n.t('home.coin_howt_ntf')}</h1>
                            <p style={styles.coin_howt_Intro}>{i18n.t('home.coin_howt_ntf_Intro')}</p>
                            <img src={IMG_NasuTF_Logo} style={styles.nasuTFLogHorizontal}/>
                            <div lassName="textArea" style={{display:"inline-block", marginLeft:"5%" ,width:"65%", verticalAlign:"top", marginTop:"0px", lineHeight:"30px"}}>
                                {i18n.t('home.coin_howt_ntf_Explan1-1')}<br/>
                                {i18n.t('home.coin_howt_ntf_Explan1-2')}<br/>
                                {i18n.t('home.coin_howt_ntf_Explan1-3')}<br/>
                                {i18n.t('home.coin_howt_ntf_Explan1-4')}
                            </div><br/>
                            <img src={IMG_NasuTF_jyoba} style={styles.nasuTFImage}/>
                            <img src={IMG_NasuTF_LogoL} style={styles.nasuTFLogoImage}/>
                        </div>
                        <p style={{height:"60px"}}></p>
                    </div>
                </div>
                </div>
                {/** 栽培工程記録 */}
                <div id="about_cultivation" style={styles.elementsColored}>
                    <h1 style={styles.title}>{i18n.t('home.before_harvest')}</h1>
                    <div className="flow8" style={styles.flowArea}>
                        <img src={GetStraw} style={styles.flowImgRight}></img>
                        <div className="textArea" style={styles.flowTextAreaLeft}>
                            <h1 style={styles.flowTitle}>{i18n.t('home.get_straw')}</h1>
                            <p style={styles.flowText}>{i18n.t('home.about_get_straw')}</p>
                            <Button variant="outlined" id={8} style={styles.flowButton} onClick={this.sendState}>
                                <text id={8}>{i18n.t('home.more_message')}</text>
                            </Button>
                            <p style={{height:"60px"}}></p>
                        </div>
                    </div>
                    <div className="flow1" style={styles.flowArea}>
                        <img src={SpreadStraw} style={styles.flowImgLeft}></img>
                        <div className="textArea" style={styles.flowTextAreaRight}>
                            <h1 style={styles.flowTitle}>{i18n.t('home.spread_straw')}</h1>
                            <p style={styles.flowText}>{i18n.t('home.about_spread_straw')}</p>
                            <Button variant="outlined" id={1} style={styles.flowButton} onClick={this.sendState}>
                                <text id={1}>{i18n.t('home.more_message')}</text>
                            </Button>
                            <p style={{height:"60px"}}></p>
                        </div>
                    </div>
                    <div className="flow2" style={styles.flowArea}>
                        <img src={StrawRecovery} style={styles.flowImgRight}></img>
                        <div className="textArea" style={styles.flowTextAreaLeft}>
                            <h1 style={styles.flowTitle}>{i18n.t('home.straw_recovery')}</h1>
                            <p style={styles.flowText}>{i18n.t('home.about_straw_recovery')}</p>
                            <Button variant="outlined" id={2} style={styles.flowButton} onClick={this.sendState}>
                                <text id={2}>{i18n.t('home.more_message')}</text>
                            </Button>
                            <p style={{height:"60px"}}></p>
                        </div>
                    </div>
                    <div className="flow3" style={styles.flowArea}>
                        <img src={StrawConvey} style={styles.flowImgLeft}></img>
                        <div className="textArea" style={styles.flowTextAreaRight}>
                            <h1 style={styles.flowTitle}>{i18n.t('home.straw_convey')}</h1>
                            <p style={styles.flowText}>{i18n.t('home.about_straw_convey')}</p>
                            <Button variant="outlined" id={3} style={styles.flowButton} onClick={this.sendState}>
                                <text id={3}>{i18n.t('home.more_message')}</text>
                            </Button>
                            <p style={{height:"60px"}}></p>
                        </div>
                    </div>
                    <div className="flow4" style={styles.flowArea}>
                        <img src={MushroomBed} style={styles.flowImgRight}></img>
                        <div className="textArea" style={styles.flowTextAreaLeft}>
                            <h1 style={styles.flowTitle}>{i18n.t('home.mushroom_bed')}</h1>
                            <p style={styles.flowText}>{i18n.t('home.about_mushroom_bed')}</p>
                            <Button variant="outlined" id={4} style={styles.flowButton} onClick={this.sendState}>
                                <text id={4}>{i18n.t('home.more_message')}</text>
                            </Button>
                            <p style={{height:"60px"}}></p>
                        </div>
                    </div>
                    <div className="flow5" style={styles.flowArea}>
                        <img src={BeginCultivation} style={styles.flowImgLeft}></img>
                        <div className="textArea" style={styles.flowTextAreaRight}>
                            <h1 style={styles.flowTitle}>{i18n.t('home.begin_cultivation')}</h1>
                            <p style={styles.flowText}>{i18n.t('home.about_begin_cultivation')}</p>
                            <Button variant="outlined" id={5} style={styles.flowButton} onClick={this.sendState}>
                                <text id={5}>{i18n.t('home.more_message')}</text>
                            </Button>
                            <p style={{height:"60px"}}></p>
                        </div>
                    </div>
                    <div className="flow6" style={styles.flowArea}>
                        <img src={Cultivation} style={styles.flowImgRight}></img>
                        <div className="textArea" style={styles.flowTextAreaLeft}>
                            <h1 style={styles.flowTitle}>{i18n.t('home.cultivation')}</h1>
                            <p style={styles.flowText}>{i18n.t('home.about_cultivation')}</p>
                            <Button variant="outlined" id={6} style={styles.flowButton} onClick={this.sendState}>
                                <text id={6}>{i18n.t('home.more_message')}</text>
                            </Button>
                            <p style={{height:"60px"}}></p>
                        </div>
                    </div>
                    <div className="flow7" style={{border:"1px solid white", paddingBottom:"870px"}}>
                        <img src={Harvest} style={styles.flowImgLeft}></img>
                        <div className="textArea" style={styles.flowTextAreaRight}>
                            <h1 style={styles.flowTitle}>{i18n.t('home.harvest')}</h1>
                            <p style={styles.flowText}>{i18n.t('home.about_harvest')}</p>
                            <Button variant="outlined" id={7} style={styles.flowButton} onClick={this.sendState}>
                                <text id={7}>{i18n.t('home.more_message')}</text>
                            </Button>
                            <p style={{height:"60px"}}></p>
                        </div>
                    </div>
                </div>
                {/** お問合せ */}
                <div id="contact_us" style={styles.elements}>
                    <p style={{fontSize:"40px", fontWeight:"600", textAlign:"center", marginTop:"20px", marginBottom:"30px",}}>{i18n.t('home.contact_us')}</p>
                    <div style={{textAlign:"center"}}>
                        <p style={{fontSize:"25px"}}>{i18n.t('home.contact_us_label')}</p>
                        <Button variant="outlined" href="https://geo-farm.com/contact/#mw_wp_form_mw-wp-form-540" target="_Blank" style={{fontSize:"25px", margin:"10px 0", color:"black"}}>
                            {i18n.t('home.contact_us_access')}
                        </Button>
                    </div>
                </div>
                {/** 協賛 */}
                <div id="partners" style={styles.elementsColored}>
                    <p style={styles.title}>{i18n.t('home.partners')}</p>
                    <div className="partnersArea">
                        {partners}
                    </div>
                    <p style={styles.pPartners}></p>
                </div>
                <a href="#">
                    <button className="returnTopButton" style={styles.returnTopButton}>
                        <ArrowUpwardIcon style={{fontSize:"60px", color:"black", textAlign:"center", marginRight:"5px"}}/>
                    </button>
                </a>
            </div>
        );
    }
}
const styles = {
    elements:{
        border: "1px solid white",
        width:"100%",
        minHeight:"320px",
        fontSize:"25px"
    },
    elementsColored:{
        border: "1px solid white",
        width:"100%",
        minHeight:"350px",
        background:"#F7EEE1",
        fontSize:"25px"
    },
    title:{
        fontSize:"40px",
        fontWeight:"600",
        textAlign:"center",
        marginTop:"60px",
        marginBottom:"30px",
    },
    portalImg:{
        width:"100%",
        height:"auto",
        WebkitFilter:"brightness(50%)",
        filter:"brightness(50%)",
        zIndex:"1"
    },
    logoImg:{
        position:"absolute",
        left:"50%",
        marginLeft:"-160px",
        marginTop:"50px",
        zIndex:"2",
    },
    geoCaicaLogoImg:{
        marginLeft:"35%",
        width:"65%",
        height:"auto"
    },
    portalTextArea:{
        width:"90%",
        marginLeft:"5%",
        position:"absolute", 
        zIndex:"2", 
        textAlign:"center", 
        marginTop:"220px", 
        color:"white"
    },
    portalTitle:{
        fontSize:"40px",
        fontWeight:"600",
    },
    portalText:{
        fontSize:"25px",
        lineHeight:"45px",
        marginTop:"-30px",
        color:"#D8D6D6"
    },
    introductionTitle:{
        fontSize:"35px", 
        fontWeight:"600",
        lineHeight:"55px",
        textAlign:"center",
        width:"90%",
        marginLeft:"5%"
    },
    introductionText:{
        fontSize:"25px",
        lineHeight:"45px",
        marginTop:"20px"
    },
    pIntroduction:{
        height:"550px"
    },
    blockChainImage:{
        width:"40%", 
        marginLeft:"2%", 
        marginTop:"110px", 
        display:"inline-block"
    },
    blockChainImage_coin:{
        width:"40%", 
        marginLeft:"2%", 
        marginTop:"10px", 
        display:"inline-block"
    },
    textRight:{
        fontSize:"25px",
        lineHeight:"45px",
        marginTop:"20px"
    },
    pBlockChain:{
        height:"40px"
    },
    flowArea:{
        border:"1px solid #F7EEE1", 
        height:"790px",
        marginBottom:"20px",
    },
    flowImgLeft:{
        width:"60%", 
        position:"absolute",
        left:"0",
        zIndex:"auto"
    },
    flowImgRight:{
        width:"60%", 
        position:"absolute", 
        right:"0",
        zIndex:"auto"
    },
    flowTextAreaLeft:{
        background:"#EFF7EA", 
        position:"relative", 
        float:"left",
        right:"1%",
        width:"750px", 
        marginTop:"470px",
    },
    flowTextAreaRight:{
        background:"#EFF7EA", 
        position:"absolute", 
        right:"0",
        width:"750px", 
        marginTop:"470px"
    },
    flowTitle:{
        fontSize:"35px", 
        fontWeight:"600",
        position:"relative", 
        width:"700px",
        left:"50px", 
        top:"30px"
    },
    flowText:{
        fontSize:"25px", 
        position:"relative", 
        left:"60px", 
        width:"630px",
        top:"40px",
        lineHeight:"47px"
    },
    flowButton:{
        fontSize:"25px", 
        position:"relative", 
        left:"60px", 
        top:"40px", 
        color:"black",
        marginBottom:"5px"
    },
    pPartners:{
        height:"60px"
    },
    returnTopButton:{
        appearance:"none",
        MozAppearance: "none",
        WebkitAppearance:"none",
        position:"fixed", 
        bottom:"70px", 
        right:"5%", 
        height:"80px", 
        width:"80px", 
        background:"white"
    },
    nelCafeLogoHorizontal:{
        width:"30%", 
        marginLeft:"15px", 
        marginTop:"5px", 
        display:"inline-block"
    },
    nelCafeImage:{
        width:"20%", 
        marginRight:"5%", 
        marginTop:"20px", 
        display:"inline-block"
    },
    /* ---------maintenance#2 T.K-------- */
    nasuTFLogHorizontal:{
        width:"20%", 
        marginLeft:"15px", 
        marginTop:"5px", 
        display:"inline-block"
    },
    nasuTFLogoImage:{
        width:"40%", 
        marginLeft:"15px", 
        marginTop:"20px", 
        display:"inline-block"
    },
    nasuTFImage:{
        width:"28%", 
        marginLeft:"15px", 
        marginTop:"20px", 
        display:"inline-block"
    },
    /* ---------maintenance#2-------- */
    coin_howt_Block:{
        marginLeft:"15px",
        lineHeight:"25px",
    },
    coin_howbuy_Address:{
        display:"inline-block",
        marginLeft:"5%" ,
        width:"95%",
        verticalAlign:"top",
        marginTop:"0px"
    },
    coin_howt_Title:{
        fontSize:"35px",
        marginTop:"30px"
    },
    coin_howt_Item:{
        fontSize:"25px",
        marginTop:"20px",
        lineHeight:"45px"
    },
    coin_howt_Intro:{
        fontSize:"25px",
        marginLeft:"18px",
        marginTop:"5px",
        lineHeight:"45px",
        width:"95%"
    },
    coin_howt_Sale_Title:{
        marginTop:"5px",
        lineHeight:"45px",
        fontSize:"25px"
    },    
    coin_howt_Sale_top:{
        marginTop:"5px"
    },    
    coin_howto_Sales_note:{
        marginLeft:"20px",
        fontSize:"25px"
    },
    coin_howt_Sale_addr:{
        display:"inline-block", 
        marginLeft:"5%" ,
        width:"50%", 
        verticalAlign:"top", 
        marginTop:"10px",
        fontSize:"17px"
    },
    coin_sub_title:{
        fontSize:"35px",
        marginTop:"65px",
        marginBottom:"10px"
    },
    partners_area:{
        marginTop:"20px", 
        marginLeft:"32%",
        fontSize:"19px"
    },
    partners_logo:{
        width:"130px", 
        marginRight:"60px"
    },
    stores_company_list:{
        fontSize:"25px",
        marginTop:"18px",
        marginLeft:"45px",
        color:"blue",
        textDecoration:"underline"
    }
}
export default withRouter(MoblieHome);